import { render, staticRenderFns } from "./AccountAdvancedSettings.vue?vue&type=template&id=3ba1733c&"
import script from "./AccountAdvancedSettings.vue?vue&type=script&lang=js&"
export * from "./AccountAdvancedSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports